import styled from 'styled-components';

export const Container = styled.div`
  .label {
    font-size: 0.8571428571428571em;
    font-style: inherit;
    color: var(--ds-text-lowEmphasis, var(--ds-text-lowEmphasis, #6b778c));
    font-weight: 600;
    line-height: 1.3333333333333333;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    margin-top: 6px;
  }
`;

export const SeparatorVertical = styled.div`
  width: 1px;
  height: 90px;
  margin-top: 10px;
  height: 95%;
  background-color: #ccc;
`;

export const ContainerObservacao = styled.div`
  width: 100%;
  height: 100%;
  .separator {
   margin-bottom: -14px;
`;
